import { useLayoutEffect, useRef } from "react";
import { createPortal } from "react-dom";

type Props = {
  children: React.ReactNode;
};
export const Portal = ({ children }: Props) => {
  const parentRef = useRef<HTMLDivElement | null>(null);
  if (!parentRef.current) {
    parentRef.current = document.createElement("div");
  }
  useLayoutEffect(() => {
    const el = parentRef.current!;
    document.body.appendChild(el);
    return () => {
      document.body.removeChild(el);
    };
  }, []);
  return createPortal(children, parentRef.current);
};
